export default __webpack_public_path__ + "static/media/online_guide_for_programming_exercise.acc4d987.pdf";